import { BuildMetaTagsProps, BuildTagsProps, TagProps } from './types'

const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || ''
const FACEBOOK_ADMINS = process.env.NEXT_PUBLIC_FACEBOOK_ADMINS || ''
const JUSBRASIL_LOGO = 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png'
const IMAGE_WIDTH = '1200'
const IMAGE_HEIGHT = '675'

const addProtocolToUrl = (url: string) => (url.startsWith('//') ? `https:${url}` : url)

const getDocumentImage = (document: BuildMetaTagsProps['document']) => {
  const { images, publisher } = document
  const documentImage =
    images?.[0]?.thumbor?.thumbUrl || publisher?.thumborAvatar?.thumbUrl || JUSBRASIL_LOGO
  return addProtocolToUrl(documentImage)
}

const buildMetaTags = (props: BuildMetaTagsProps) => {
  const { document, title, description, noIndex, ogType = 'article' } = props
  const { publisher, url } = document

  const image = getDocumentImage(document)
  const authorUrl = publisher?.url ? addProtocolToUrl(publisher.url) : null

  return [
    { name: 'robots', content: noIndex ? 'noindex' : 'index,follow' },
    { property: 'fb:app_id', content: FACEBOOK_APP_ID },
    { property: 'fb:admins', content: FACEBOOK_ADMINS },
    { property: 'og:url', content: url || '' },
    { property: 'og:type', content: ogType },
    { property: 'og:title', content: title },
    { property: 'og:image', content: image },
    { property: 'og:image:alt', content: title },
    { property: 'og:image:width', content: IMAGE_WIDTH },
    { property: 'og:image:height', content: IMAGE_HEIGHT },
    { property: 'og:locale', content: 'pt_BR' },
    { property: 'og:description', content: description },
    { property: 'og:site_name', content: 'Jusbrasil' },
    { property: 'article:author', content: authorUrl || '' },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:site', content: '@Jusbrasil' },
    { name: 'twitter:url', content: url || '' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: image },
  ]
}

export const buildTags = (props: BuildTagsProps): TagProps => {
  const { document, seoMetadata } = props
  const { title, description, keywords, structuredData } = seoMetadata

  return {
    title,
    meta: [
      ...buildMetaTags({ document, ...seoMetadata }),
      { name: 'description', content: description },
      { name: 'keywords', content: keywords.join(', ') },
    ].filter((metaTag) => !!metaTag.content),
    structuredData,
  }
}
